<template>
  <section>
    <CommonHeader />
    <div>
      <DrawMenu :menuList="rowMenuList.menuList" :root="rowMenuList.root"></DrawMenu>
      <section
        class="tw-container tw-mx-auto tw-flex tw-flex-col tw-gap-10 sm:tw-gap-20 md:sm:tw-gap-24 lg:tw-gap-28 tw-py-7 sm:tw-py-10 md:tw-py-16 lg:tw-py-24"
      >
        <div class="tw-px-0 md:tw-px-10 lg:tw-px-20 xl:tw-px-32">
          <div class="lg:tw-hidden tw-mb-5">
            <h1 class="tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-leading-tight tw-font-black">
              <span class="tw-text-primary">{{ $t('legend-trading') }} </span>
              <br />
              <span> {{ $t('payments-infrastructure', []) }}</span>
            </h1>
            <p class="tw-text-base md:tw-text-lg tw-mt-5 md:tw-mt-2">{{ $t('integration-guides-and-documentations') }} </p>
          </div>
          <div class="tw-flex tw-flex-col tw-gap-7 md:tw-flex-row tw-justify-center">
            <div class="tw-basis-full md:tw-basis-1/2 md:tw-order-last">
              <div class="tw-w-full tw-h-full tw-flex tw-justify-end">
                <NuxtImg src="/res/img/developers/header-artwork.png" alt="header-artwork" />
              </div>
            </div>
            <div class="tw-basis-full md:tw-basis-1/2 tw-flex tw-items-center tw-justify-end">
              <div class="xl:tw-ml-10">
                <div class="tw-hidden lg:tw-block tw-mb-5">
                  <h1 class="tw-text-3xl md:tw-text-4xl lg:tw-text-5xl tw-font-black">
                    <span class="tw-text-primary tw-leading-tight">{{ $t('legend-trading') }}</span>
                    <br />
                    <span class="tw-leading-tight"> {{ $t('payments-infrastructure', []) }}</span>
                  </h1>

                  <p class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-mt-5 md:tw-mt-2"
                    >{{ $t('integration-guides-and-documentations') }}
                  </p>
                </div>
                <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black" id="overview">{{ $t('overview') }}</h2>
                <p class="tw-mt-2 tw-text-sm md:tw-text-base lg:tw-text-lg !tw-leading-relaxed">
                  {{
                    $t(
                      'legend-tradings-payment-infrastructure-is-a-fiat-on-and-off-ramp-saas-combining-compliance-banking-payment-and-trading-solutions-for-your-applications-exchanges-wallets-nft-marketplaces-and-other-blockchain-products-and-services-to-bridge-the-gap-between-the-cryptocurrency-space-and-traditional-financial-systems',
                    )
                  }}
                </p>
              </div>
            </div>
            <div class="tw-basis-full md:tw-hidden">
              <div class="tw-bg-accent tw-flex tw-items-center tw-px-6 tw-py-8 tw-rounded-[20px]">
                <div class="tw-flex tw-flex-col tw-gap-4">
                  <h1 class="tw-text-2xl tw-font-black tw-text-white"> {{ $t('INDEX') }} </h1>
                  <ul class="tw-flex tw-flex-col tw-gap-2">
                    <li v-for="(item, index) in rowMenuList.menuList" :key="index" class="tw-flex tw-gap-2">
                      <SvgoShadowbgShapeInterrupt class="tw-w-[10px] tw-fill-primary" />
                      <a :href="`#${item.key}`" class="tw-text-white tw-underline">{{ item.name }}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <section class="tw-card tw-bg-secondary tw-py-14 tw-px-6 tw-rounded-2xl md:tw-rounded-3xl">
          <div class="tw-px-0 md:tw-px-10 lg:tw-px-20 xl:tw-px-32">
            <div class="tw-flex tw-flex-col tw-gap-14 tw-justify-center tw-items-center tw-text-center">
              <div class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mx-auto tw-max-w-[660px]">
                <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black !tw-leading-normal"
                  >{{ $t('build-your-own-coinbase-or-opensea') }}
                </h2>
                <p class="md:tw-leading-normal tw-leading-relaxed tw-mt-3">
                  {{
                    $t(
                      'by-integrating-a-few-lines-of-code-you-will-be-able-to-utilize-legend-tradings-global-banking-and-trading-facilities-this-provides-you-with-the-best-solution-for-your-users-to-trade-cryptocurrencies-nfts-and-other-blockchain-products-and-services-with-a-simple-bank-transfer',
                    )
                  }}
                </p>
              </div>
              <div class="tw-flex tw-flex-col sm:tw-flex-row tw-justify-around tw-w-full tw-gap-y-7">
                <div v-for="(item, index) in feauresList" :key="index" class="tw-text-center">
                  <div class="tw-flex tw-justify-center tw-mb-5">
                    <NuxtImg :src="item.imgPath" :alt="item.altText" class="tw-h-[86px]" />
                  </div>
                  <p class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-black tw-px-5">{{ item.title }}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div class="tw-flex tw-flex-col tw-gap-14 sm:tw-gap-20 md:tw-gap-24 lg:tw-gap-28 tw-px-0 md:tw-px-10 lg:tw-px-20 xl:tw-px-32">
          <section>
            <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black" id="get_started">
              {{ $t('get-started') }}
            </h2>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-5 md:tw-mt-6 lg:tw-mt-7 !tw-leading-relaxed">
              {{
                $t(
                  'our-payment-solution-provides-an-easy-way-to-integrate-a-fiat-on-and-off-ramp-to-your-application-this-is-a-simple-solution-that-your-development-team-can-use-to-integrate-into-your-product-within-2-weeks-or-less-our-solutions-enable-our-partners-to-connect-their-users-cryptocurrency-accounts-to-their-financial-banking-institution-and-supports-the-following-features',
                )
              }}
            </p>

            <div class="tw-mt-7 md:tw-mt-8">
              <ul>
                <li v-for="(item, index) in startList" :key="index" class="tw-flex tw-items-baseline">
                  <SvgoShadowbgShapeInterrupt class="tw-mr-2 md:tw-mr-3 lg:tw-mr-4 tw-w-[14px] tw-fill-primary" />
                  <p class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-bold tw-flex-1">{{ item }}</p>
                </li>
              </ul>
            </div>
          </section>

          <VLine type="lightToDark" />

          <section class="tw-flex tw-flex-col md:tw-flex-row tw-gap-7">
            <div class="tw-basis-full md:tw-basis-1/2 tw-flex tw-flex-col tw-justify-center">
              <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black">
                {{ $t('how-it-works') }}
              </h2>
              <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-5 md:tw-mt-6 lg:tw-mt-7">
                {{
                  $t(
                    'legend-tradings-saas-provides-a-fiat-on-and-off-ramp-engine-that-has-a-built-in-customizable-ui-you-just-need-to-configure-the-parameters-for-the-embedded-pages-you-can-also-define-your-own-ui-styles-like-fonts-and-color-schemes-through-our-pre-built-blocks',
                  )
                }}
              </p>
              <h6 class="tw-mt-7 tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-bold">
                {{ $t('the-integration-consists-of-two-parts') }}
              </h6>
              <div class="tw-mt-5 md:tw-mt-2">
                <ul>
                  <li>
                    <p class="tw-text-base sm:tw-text-lg md:tw-text-xl">
                      <span class="tw-font-bold tw-mr-2 md:tw-mr-4 lg:tw-mr-5">1.</span>{{ $t('Front-end') }}
                    </p>
                  </li>
                  <li>
                    <p class="tw-text-base sm:tw-text-lg md:tw-text-xl">
                      <span class="tw-font-bold tw-mr-2 md:tw-mr-4 lg:tw-mr-5">2.</span>{{ $t('Back-end') }}
                    </p>
                  </li>
                </ul>
              </div>
              <p class="tw-mt-5 md:tw-mt-2 tw-text-sm md:tw-text-base lg:tw-text-lg">
                {{ $t('front-end-integration-is-done-via-the-javascript-sdk-while-the-back-end-is-managed-with-the-use-of-our-rest-apis') }}
              </p>
            </div>
            <div class="tw-basis-full md:tw-basis-1/2 tw-flex tw-justify-center">
              <SvgoDevelopersStructureChart class="tw-w-full" />
            </div>
          </section>
          <section class="tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-gap-6">
            <div class="tw-flex-1">
              <div class="tw-card tw-bg-secondary tw-rounded-2xl tw-text-center tw-h-full tw-py-7 md:tw-py-8 lg:tw-py-12">
                <div class="tw-flex tw-flex-col tw-justify-between tw-h-full">
                  <div class="tw-px-6">
                    <h5 class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-bold">{{ $t('web-application-live-demo') }}</h5>
                    <h6 class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-italic tw-mt-2 tw-mb-7 md:tw-mb-8 tw-text-accent/60">
                      https://demo.legendtrading.com/
                    </h6>
                  </div>
                  <div>
                    <UIButton to="https://demo.legendtrading.com/" class="tw-btn-lg">
                      {{ $t('visit-live-demo') }}
                    </UIButton>
                  </div>
                </div>
              </div>
            </div>
            <div class="tw-flex-1">
              <div class="tw-card tw-bg-secondary tw-rounded-2xl tw-text-center tw-h-full tw-py-7 md:tw-py-8 lg:tw-py-12">
                <div class="tw-flex tw-flex-col tw-justify-between tw-h-full">
                  <div class="tw-px-6">
                    <h5 class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-bold">{{ $t('mobile-application-live-demo') }}</h5>
                    <h6 class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-italic tw-mt-2 tw-mb-7 md:tw-mb-8 tw-text-accent/60">
                      https://demo.legendtrading.com/
                    </h6>
                  </div>
                  <div>
                    <UIButton to="https://demo.legendtrading.com/" class="tw-btn-lg">
                      {{ $t('visit-live-demo') }}
                    </UIButton>
                  </div>
                </div>
              </div>
            </div>
          </section>

          <VLine type="lightToDark" />

          <section>
            <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black" id="web_application">
              {{ $t('web-application') }}
            </h2>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-5 md:tw-mt-6 lg:tw-mt-7 !tw-leading-relaxed">
              {{
                $t(
                  'legend-tradings-payment-saas-provides-a-simple-way-for-third-party-platforms-to-integrate-implementing-the-fiat-trading-feature-is-as-easy-as-adding-pure-html-components-we-use-web-components-to-build-our-sdk-it-will-fallback-to-normal-htmlelement-for-compatibility-when-needed-the-javascript-sdk-is-a-spa-single-page-application-powered-by',
                )
              }}
              <span class="tw-text-primary">Vue.js</span>, <span class="tw-text-primary">Vue Router</span>
              {{ $t('and-a-few-other-front-end-libraries') }}
            </p>
            <div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-gap-6 tw-mt-7 sm:tw-mt-7 md:tw-mt-8 lg:tw-mt-10">
              <NuxtImg src="/res/img/developers/web-screen-1.png" class="tw-w-full" alt="web-screen-1" />
              <NuxtImg src="/res/img/developers/web-screen-2.png" class="tw-w-full" alt="web-screen-2" />
            </div>
          </section>

          <section>
            <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black">{{ $t('how-it-works') }}</h2>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-5 md:tw-mt-6 lg:tw-mt-7">
              {{ $t('import-vue-to-implement-the-frontend-and-configure-the-pre-defined-variables') }}
            </p>
            <div class="tw-mt-7 md:tw-mt-6 lg:tw-mt-5 tw-flex tw-flex-col tw-gap-5 sm:tw-gap-8 md:tw-gap-10 lg:tw-gap-12">
              <ul v-for="(item, index) in webWorkList" :key="index" class="tw-flex tw-flex-col tw-gap-5">
                <li class="tw-flex tw-items-baseline tw-mt-2 sm:tw-mt-3 md:tw-mt-4 lg:tw-mt-5">
                  <SvgoShadowbgShapeInterrupt class="tw-mr-2 md:tw-mr-3 lg:tw-mr-4 tw-w-[14px] tw-fill-primary" />
                  <h6 class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-flex-1">{{ item.title }}</h6>
                </li>
                <ClientOnly>
                  <VGist :gist-id="item.gistId" :file="item.fileName" />
                </ClientOnly>
              </ul>
            </div>
            <h6 class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-bold tw-mt-7 sm:tw-mt-8 md:tw-mt-10 lg:tw-mt-14"
              >{{ $t('web-application-live-demo') }}
            </h6>
            <h6 class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-italic tw-mt-2 tw-mb-7 md:tw-mb-8 tw-text-accent/60">
              https://demo.legendtrading.com/
            </h6>
            <div>
              <UIButton to="https://demo.legendtrading.com/" class="tw-btn-lg">
                {{ $t('visit-live-demo') }}
              </UIButton>
            </div>
          </section>

          <VLine type="lightToDark" />

          <section>
            <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black" id="mobile_application">{{ $t('mobile-application') }} </h2>
            <i18n-t
              keypath="legend-tradings-mobile-sdk-provides-a-simple-way-for-third-party-platforms-to-integrate-implementing-the-fiat-on-and-off-ramp-feature-is-as-easy-as-adding-pure-html-components-we-use-web-components-to-build-our-mobile-sdk-it-will-fallback-to-normal-htmlelement-for-compatibility-the-mobile-sdk-is-a-spa-powered-by"
              tag="p"
              class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-5 md:tw-mt-6 lg:tw-mt-7"
            >
              <span class="tw-text-primary">React</span>
              <span class="tw-text-primary">React Router</span>
              <span class="tw-text-primary">Material UI</span>
            </i18n-t>
            <ClientOnly>
              <div class="tw-mt-7 md:tw-mt-8 lg:tw-mt-10">
                <Swiper
                  :slidesPerView="1.5"
                  :grabCursor="true"
                  :spaceBetween="30"
                  :breakpoints="{
                    '640': {
                      slidesPerView: 2.5,
                      spaceBetween: 20,
                    },
                    '1024': {
                      slidesPerView: 3.5,
                      spaceBetween: 50,
                    },
                  }"
                  :modules="[Pagination]"
                >
                  <SwiperSlide class="!tw-flex tw-justify-center">
                    <NuxtImg class="tw-w-[244px]" src="/res/img/developers/mobile-screen-1.png" />
                  </SwiperSlide>
                  <SwiperSlide class="!tw-flex tw-justify-center">
                    <NuxtImg class="tw-w-[244px]" src="/res/img/developers/mobile-screen-2.png" />
                  </SwiperSlide>
                  <SwiperSlide class="!tw-flex tw-justify-center">
                    <NuxtImg class="tw-w-[244px]" src="/res/img/developers/mobile-screen-3.png" />
                  </SwiperSlide>
                  <SwiperSlide class="!tw-flex tw-justify-center">
                    <NuxtImg class="tw-w-[244px]" src="/res/img/developers/mobile-screen-4.png" />
                  </SwiperSlide>
                </Swiper>
              </div>
            </ClientOnly>
          </section>

          <section>
            <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black">{{ $t('how-it-works') }}</h2>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-5 md:tw-mt-6 lg:tw-mt-7">
              {{ $t('import-react-as-externalized-in-your-web-page-to-implement-the-frontend-and-configure-the-pre-defined-variables') }}
            </p>
            <div class="tw-mt-7 md:tw-mt-8 lg:tw-mt-10">
              <ClientOnly>
                <VGist gist-id="03e16d44b4247f2358a75defe2bb766c" file="mobile-demo-externalize.html" />
              </ClientOnly>
            </div>

            <h6 class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-bold tw-mt-7 sm:tw-mt-8 md:tw-mt-10 lg:tw-mt-14">{{
              $t('mobile-application-live-demo-visit-from-a-mobile-device')
            }}</h6>
            <p class="tw-font-italic tw-mt-2 tw-mb-7 md:tw-mb-8 tw-text-sm md:tw-text-base lg:tw-text-lg">
              https://demo.legendtrading.com/
            </p>
            <div>
              <UIButton to="https://demo.legendtrading.com/" class="tw-btn-lg">
                {{ $t('visit-live-demo') }}
              </UIButton>
            </div>
          </section>
        </div>

        <section
          class="tw-card tw-bg-secondary tw-px-5 tw-py-14 tw-rounded-2xl md:tw-rounded-3xl tw-px-0 md:tw-px-10 lg:tw-px-20 xl:tw-px-32"
        >
          <div>
            <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black" id="rest_api">{{ $t('rest-api') }}</h2>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-5 md:tw-mt-2 !tw-leading-relaxed">
              {{
                $t(
                  'by-integrating-our-api-endpoints-youll-be-able-to-obtain-details-and-run-transactions-for-a-specified-account-including-rfq-request-for-quote-trades-and-settlements-the-api-supports-the-following-account-actions',
                )
              }}
            </p>
            <div class="tw-mt-7 sm:tw-mt-8 md:tw-mt-10 lg:tw-mt-15">
              <ul class="tw-grid tw-gap-2">
                <li v-for="(item, index) in apiList" :key="index" class="tw-flex align-baseline">
                  <SvgoShadowbgShapeInterrupt class="tw-mr-2 md:tw-mr-3 lg:tw-mr-4 tw-w-[14px] tw-fill-primary" />
                  <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-flex-1">{{ item }}</p>
                </li>
              </ul>
            </div>
          </div>
        </section>

        <div class="tw-flex tw-flex-col tw-gap-14 md:tw-gap-24 tw-px-0 md:tw-px-10 lg:tw-px-20 xl:tw-px-32">
          <div>
            <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black">{{ $t('sample-code-python') }}</h2>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-5 md:tw-mt-6 lg:tw-mt-7 tw-gap-2 !tw-leading-relaxed">
              {{ $t('the-sample-code-below-shows-how-to-get-the-trade-history-of-all-the-users-belong-to-your-exchange') }}
            </p>
            <div class="tw-mt-7 sm:tw-mt-8 md:tw-mt-10 lg:tw-mt-14">
              <ClientOnly>
                <VGist gist-id="c93694fb6cc3de30d3713120eb458e50" file="python-demo.py" />
              </ClientOnly>
            </div>
          </div>

          <div>
            <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black">{{ $t('authentication') }}</h2>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-5 md:tw-mt-6 lg:tw-mt-7 !tw-leading-relaxed">
              {{
                $t(
                  'all-of-our-api-endpoints-are-private-you-will-need-to-use-a-token-for-authentication-when-you-access-these-endpoints-please-contact-us-to-get-the-token-the-bearer-token-will-need-to-be-in-the-http-header-for-every-api-requ',
                )
              }}
            </p>
            <h6 class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-bold tw-mt-7 sm:tw-mt-8 md:tw-mt-10 lg:tw-mt-14">{{
              $t('http-header')
            }}</h6>
            <div class="tw-mt-5 md:tw-mt-6 lg:tw-mt-7">
              <ClientOnly>
                <VGist gist-id="ecdd0055f9e0904944874a3d03ae6a1c" file="python-http-header.txt" />
              </ClientOnly>
            </div>
            <h6 class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-bold tw-mt-5 md:tw-mt-6 lg:tw-mt-7">{{
              $t('sample-code-python')
            }}</h6>
            <div class="tw-mt-5 md:tw-mt-6 lg:tw-mt-7">
              <ClientOnly>
                <VGist gist-id="c93694fb6cc3de30d3713120eb458e50" file="python-demo.py" />
              </ClientOnly>
            </div>
          </div>
        </div>

        <section
          class="tw-rounded-2xl md:tw-rounded-3xl tw-py-14 tw-px-5 tw-border tw-border-primary error-code tw-px-0 md:tw-px-10 lg:tw-px-20 xl:tw-px-32"
        >
          <div>
            <h4 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black">{{ $t('error-code') }}</h4>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-2">{{
              $t('the-table-below-defines-the-error-codes-and-the-descriptions')
            }}</p>
            <table class="table tw-w-full tw-mt-7 sm:tw-mt-8 md:tw-mt-10 lg:tw-mt-14 tw-text-base sm:tw-text-lg md:tw-text-xl">
              <tbody>
                <tr>
                  <th>{{ $t('error-code') }}</th>
                  <th>{{ $t('description') }}</th>
                </tr>
                <tr>
                  <td>401</td>
                  <td>{{ $t('unauthenticated') }}</td>
                </tr>
                <tr>
                  <td>404</td>
                  <td>{{ $t('not-found-the-specified-endpoint-could-not-be-found') }}</td>
                </tr>
                <tr>
                  <td>405</td>
                  <td>
                    {{ $t('the-get-method-is-not-supported-for-this-route-supported-methods-post') }}
                  </td>
                </tr>
                <tr>
                  <td>422</td>
                  <td>{{ $t('the-given-data-was-invalid') }}</td>
                </tr>
              </tbody>
            </table>
            <div class="tw-mt-7 sm:tw-mt-8 md:tw-mt-10 lg:tw-mt-14">
              <ClientOnly>
                <VGist gist-id="c41ec909091d2e272796c1d31f74cbf5" file="error-code.json" />
              </ClientOnly>
            </div>
          </div>
        </section>

        <div class="tw-px-0 md:tw-px-10 lg:tw-px-20 xl:tw-px-32">
          <div>
            <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black" id="development_testing"
              >{{ $t('development-and-testing') }}
            </h2>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-2 sm:tw-mt-3 md:tw-mt-5 lg:tw-mt-7 !tw-leading-relaxed">
              {{
                $t(
                  'when-you-have-completed-your-development-you-can-create-a-test-account-to-test-your-application-you-will-need-to-obtain-tokens-from-us-to-be-able-to-access-the-test-net-you-will-need-to-provide-us-with-your-test-account-information-so-that-we-can-add-it-to-our-whitelist-we-will-credit-your-account-in-usd-for-the-test-trades-you-perform',
                )
              }}
            </p>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-7 md:tw-mt-8 lg:tw-mt-10 !tw-leading-relaxed">
              {{ $t('heres-the-live-demo-for-your-reference-click-enable-now-to-start-creating-your-test-account-for-kyc') }}
            </p>
            <p class="tw-italic tw-text-sm md:tw-text-base lg:tw-text-lg tw-mt-2 sm:tw-mt-3 md:tw-mt-4 tw-mb-8 tw-text-accent/60">
              https://demo.legendtrading.com/</p
            >
            <div>
              <UIButton to="https://demo.legendtrading.com/" class="tw-btn-lg">
                {{ $t('visit-live-demo') }}
              </UIButton>
            </div>
          </div>
        </div>

        <section
          class="tw-bg-accent tw-rounded-2xl md:tw-rounded-3xl tw-py-14 sm:tw-py-16 md:tw-py-20 lg:tw-py-24 tw-text-white tw-text-center tw-px-0 md:tw-px-10 lg:tw-px-20 xl:tw-px-32"
        >
          <div>
            <h4 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black tw-mb-8 sm:tw-mb-14 md:tw-mb-16 lg:tw-mb-18 tw-px-5">{{
              $t('purchase-crypto-with-bank-transfer')
            }}</h4>
            <div class="tw-flex tw-justify-around tw-items-center tw-flex-col md:tw-flex-row tw-px-5 tw-gap-4">
              <template v-for="(item, index) in purchaseList" :key="index">
                <div class="tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-5">
                  <NuxtImg :src="item.imgPath" :alt="item.altText" class="tw-max-h-[100px] tw-h-full" />
                  <h5 class="tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-black" v-html="item.title"></h5>
                </div>
                <div
                  v-if="index !== purchaseList.length - 1"
                  class="tw-flex-none tw-flex tw-justify-around tw-items-center tw-w-[72px] tw-h-[72px]"
                >
                  <SvgoDevelopersGradientArrow class="tw-w-full tw-h-[10px] tw-rotate-90 tw-origin-center md:tw-rotate-0" />
                </div>
              </template>
            </div>
            <div class="tw-flex tw-justify-center tw-mt-10 tw-btn-lg">
              <UIButton class="tw-btn-lg lg:tw-btn-xl">
                {{ $t('enable-now') }}
              </UIButton>
            </div>
            <div
              class="tw-flex tw-justify-center tw-items-center tw-text-base sm:tw-text-lg md:tw-text-xl tw-font-black tw-mt-16 md:tw-mt-14 tw-mb-5 md:tw-mb-3"
            >
              {{ $t('powered-by') }}
              <p class="tw-ml-3">
                <SvgoDevelopersLogoGoldExtended class="tw-h-full" />
              </p>
            </div>
            <p class="tw-text-sm md:tw-text-base lg:tw-text-lg">
              {{ $t('the-leading-crypto-trading-firm') }} <br />
              {{ $t('trusted-by-800-professional-institutions') }}
            </p>
          </div>
        </section>

        <div class="tw-text-center">
          <h2 class="tw-text-2xl md:tw-text-3xl lg:tw-text-4xl tw-font-black">{{ $t('contact-us-to-get-full-integration-documents') }}</h2>
          <p class="tw-text-base md:tw-text-lg tw-mt-5 md:tw-mt-2 !tw-leading-relaxed">{{
            $t('lets-build-the-future-of-finance-together')
          }}</p>
          <div class="tw-flex tw-justify-center tw-mt-10 md:tw-mt-12 lg:tw-mt-14">
            <UIButton @click="onTouched" class="tw-btn-lg">
              {{ $t('become-a-partner') }}
            </UIButton>
          </div>
        </div>
      </section>
    </div>
  </section>
</template>

<script lang="ts" setup>
  import { Pagination } from 'swiper/modules'
  import { Swiper, SwiperSlide } from 'swiper/vue'

  import 'swiper/css'
  import 'swiper/css/pagination'

  const { t } = useI18n()
  const rowMenuList = computed(() => ({
    root: 'developers',
    menuList: [
      {
        key: 'overview',
        name: t('overview'),
      },
      {
        key: 'get_started',
        name: t('get-started'),
      },
      {
        key: 'web_application',
        name: t('web-application'),
      },
      {
        key: 'mobile_application',
        name: t('mobile-application'),
      },
      {
        key: 'rest_api',
        name: t('rest-api'),
      },
      {
        key: 'development_testing',
        name: t('development-and-testing'),
      },
    ],
  }))
  const feauresList = computed(() => [
    {
      title: t('easy-for-integration-with-web-components'),
      imgPath: '/res/img/developers/easy-icon.svg',
      altText: 'easy-icon',
    },
    {
      title: t('strong-security-with-oauth-2-0'),
      imgPath: '/res/img/developers/safety-icon.svg',
      altText: 'safety-icon',
    },
    {
      title: t('customized-themes-and-configurations'),
      imgPath: '/res/img/developers/custom-icon.svg',
      altText: 'custom-icon',
    },
  ])
  const startList = computed(() => [
    t('know-your-customer-kyc'),
    t('deposit-withdraw-fiat-assets-with-bank-transfers'),
    t('buy-and-sell-cryptocurrency'),
    t('transfer-cryptocurrency-assets-to-and-from-user-wallets-for-trading-purposes'),
    t('track-user-account-metrics'),
  ])
  const webWorkList = computed(() => [
    {
      title: t('vue-is-externalized-in-your-website'),
      gistId: '44602b1aa85145f218df34ec75bc0bff',
      fileName: 'web-demo-externalize.html',
    },
    {
      title: t('vue-is-inline-with-legend-sdk'),
      gistId: 'eef4ff247903dedd7f04591be82b533f',
      fileName: 'web-demo-inline.html',
    },
  ])
  const apiList = computed(() => [
    t('get-an-indicative-quote-check-price'),
    t('execute-a-trade-using-a-quote-you-received-for-a-specified-user'),
    t('get-all-available-trading-pairs'),
    t('get-the-trade-history-of-all-your-users'),
    t('get-asset-balance-for-the-specific-user'),
    t('get-the-settlement-history-of-all-your-users'),
    t('get-details-of-a-specific-trade'),
    t('get-the-rfq-request-for-quote-history-of-all-your-users'),
    t('get-a-trade-detail-by-quote-id'),
    t('get-the-kyc-status'),
  ])
  const purchaseList = computed(() => [
    {
      title: t('verify-identity'),
      imgPath: '/res/img/developers/id-icon.svg',
      altText: 'id-icon',
    },
    {
      title: t('make-a-bank-transfer'),
      imgPath: '/res/img/developers/bank-icon.svg',
      altText: 'bank-icon',
    },
    {
      title: t('start-trading'),
      imgPath: '/res/img/developers/trading-icon.svg',
      altText: 'trading-icon',
    },
  ])

  const zenDesk = useZenDesk()
  const onTouched = () => {
    zenDesk.onToggle()
  }
  definePageMeta({
    middleware: ['sosovalue','ip2location'],
  })
</script>
<style scoped lang="scss">
  // .arrow-wrapper {
  //   height: 72px;
  //   margin: 10px;

  //   .arrow {
  //     width: 72px;
  //     transform: rotate(90deg);
  //   }

  //   @media (min-width: 600px) {
  //     .arrow {
  //       width: 80%;
  //       transform: rotate(0deg);
  //     }
  //   }
  // }
  .error-code {
    border: 1px solid colors(theme);

    table {
      border-collapse: collapse;
      font-size: 16px;
      line-height: 1.5;
      text-align: left;

      td,
      th {
        padding: 10px 20px;
      }

      tr th {
        font-weight: 600;
        color: colors(dark);
        height: 4.375rem;
      }

      tr th:first-child {
        background-color: rgba(197, 171, 128, 0.2);
        border: solid colors(theme);
        border-width: 0px 1px 0px 0px;
      }

      tr th:last-child {
        background: rgba(206, 206, 208, 0.2);
      }

      tr:first-child {
        border: none;
      }

      tr {
        border-bottom: 1px solid colors(theme);
      }

      tr td:first-child {
        color: colors(dark);
        width: 40%;
        border: solid colors(theme);
        border-width: 0px 1px 0px 0px;
      }

      tr td:last-child {
        color: #9d9da2;
        border-right: none;
      }

      tr:last-child {
        border: none;
      }
    }
  }
</style>
